import { render, staticRenderFns } from "./RolePermissionsModal.vue?vue&type=template&id=c441f010&scoped=true&"
import script from "./RolePermissionsModal.vue?vue&type=script&lang=js&"
export * from "./RolePermissionsModal.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionsModal.vue?vue&type=style&index=0&id=c441f010&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c441f010",
  null
  
)

export default component.exports